// extracted by mini-css-extract-plugin
export default {"customTab":"OpportunityTabs_customTab__YP4n-"};